import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { crearProceso, getClientes } from '../api';

const ProcesoModal = ({ isOpen, onClose, onRefresh }) => {
  const [formData, setFormData] = useState({
    titulo: '',
    ClienteId: ''
  });
  const [clientes, setClientes] = useState([]);

  useEffect(() => {
    if (isOpen) {
      getClientes().then(res => setClientes(res.data)).catch(console.error);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await crearProceso(formData);
      onRefresh(); // Refresca la lista de procesos
      setFormData({ titulo: '', ClienteId: '' }); // Limpia el form
      onClose();   // Cierra el modal
    } catch (error) {
      console.error("Error al crear proceso:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg w-[400px] shadow-xl">
        <div className="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
          <h2 className="font-bold text-gray-700 uppercase text-sm">Crear Nuevo Proceso</h2>
          <X className="cursor-pointer text-gray-400 hover:text-gray-600" onClick={onClose} />
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Título del Cargo</label>
            <input 
              type="text" 
              required 
              placeholder="Ej: Jefe de Proyectos TI"
              className="w-full border rounded p-2 text-sm outline-emeral-green"
              value={formData.titulo}
              onChange={(e) => setFormData({...formData, titulo: e.target.value})}
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Asignar Cliente</label>
            <select 
              required
              className="w-full border rounded p-2 text-sm outline-emeral-green bg-white"
              value={formData.ClienteId}
              onChange={(e) => setFormData({...formData, ClienteId: e.target.value})}
            >
              <option value="" disabled>Selecciona la empresa dueña...</option>
              {clientes.map(cli => (
                <option key={cli.id} value={cli.id}>{cli.nombre}</option>
              ))}
            </select>
          </div>
          
          <div className="pt-4 flex justify-end gap-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-xs font-bold text-gray-400 uppercase">Cancelar</button>
            <button type="submit" className="bg-emeral-green text-white px-6 py-2 rounded text-xs font-bold uppercase hover:bg-opacity-90">
              Crear Proceso
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProcesoModal;
